const composeQueries = (url, objects) => {
	let queries = Object.keys(objects)
		.filter((key) => objects[key]?.toString())
		.map((key) => key + '=' + objects[key])
		.join('&');
	return url + '&' + queries;
};

export default composeQueries;
